var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full relative"},[(_vm.ctx.renderer)?_c('FastFlame'):_vm._e(),(_vm.ctx.renderer)?_c('EnergyArt',{attrs:{"pz":30}}):_vm._e(),(_vm.ctx.renderer)?_c('Bloomer',{attrs:{"settings":{
      exposure: 1.0,
      bloomStrength: 1.7,
      bloomThreshold: 81.72 / 100.0,
      bloomRadius: 72.99 / 100.0 * 2
    }}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }